import {SondageValeur} from './sondageValeur.model';
import {SondageReponse} from './sondageReponse.model';

export interface SondageInterface {
  id: number;
  libelle: string;
  type: string;
  vueResultat: boolean;
  home: boolean;
  description: string;
  path: string;
  dateDebut: Date;
  dateFin: Date;
  clos: boolean;
  dateCloture: Date | null;
  remarqueCloture: string;
  images?: object | null;
  nbReponses: number;
  vote: SondageReponse;
  valeurs: Array<SondageValeur>;
  reponses: Array<SondageReponse>;
  resultatChoix: IResultatChoix;
  resultatNote: IResulatNote;
  resultatAffirmatif: IResultatAffirmatif;
}

export namespace SondageType {
  export type TypeEnum = 'BOOL' | 'NOTE' | 'LOV';
  export const TypeEnum = {
    Affirmatif: 'BOOL' as TypeEnum,
    Note: 'NOTE' as TypeEnum,
    Choix: 'LOV' as TypeEnum
  };
}

export interface IResultatChoix {
  data: number[];
  labels: string[];
}
export interface IResulatNote {
  moyenne: number;
  min: number;
  max: number;
}
export interface IResultatAffirmatif {
  data: number[];
  labels: string[];
}



// WEBPACK FOOTER //
// ./src/shared/models/sondage/sondage.interface.ts